import trim from 'lodash/trim';

export const getHostname = () => {
  const urlSplit = window?.location?.href?.split('/');

  return urlSplit.length ? `${urlSplit[0]}//${urlSplit[2]}` : ''
}

// This is intended to be fed to Link components.
export const preserveWorkspaceURL = url => (linkObj) => {
  if (!linkObj.pathname) {
    return url;
  }

  if (url.startsWith('/workspaces/')) {
    return url;
  }

  // First / is expected to be prepended.
  const arr = linkObj.pathname.split('/');

  if (arr.length > 2) {
    return `/${arr[1]}/${arr[2]}/${trim(url, '/')}`;
  }

  return url;
}

export const getHostnameWithWorkspace = (includeHostname = true) => {
  const urlSplit = window?.location?.href?.split('/');
  for (let i = 0; i < urlSplit.length; i += 1) {
    if (urlSplit[i] === 'workspaces') {
      return includeHostname
        ? urlSplit.slice(0, i + 2).join('/')
        : urlSplit.slice(i, i + 2).join('/');
    }
  }
  return '';
}

export const getURLWithParams = (endpoint = '', params = {}) => {
  const url = endpoint.includes('http') ? new URL(endpoint) : new URL(`${getHostname()}${endpoint}`);
  const paramKeys = Object.keys(params);

  paramKeys.forEach(key => url.searchParams.append(key, params[key]));

  return url.toString();
}
